import { Carousel, CarouselSlide } from '@mantine/carousel';
import { Tabs } from '@mantine/core';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { cashdeskPageModel } from 'pages/cashdesk-page/model';
import { CashdeskPageTabValues } from 'pages/cashdesk-page/model/cashdesk-page-model';
import { CashdeskPageDevices } from '../cashdesk-page-devices';
import { CashdeskPageForm } from '../cashdesk-page-form';
import { CashdeskPagePlayers } from '../cashdesk-page-players';
import cls from './cashdesk-page-tabs.module.scss';

export const CashdeskPageTabs = () => {
	const { t } = useTranslation();

	const { value, setValue } = useUnit(cashdeskPageModel.currentTabState);

	return (
		<Tabs
			variant='default'
			keepMounted={false}
			classNames={{
				root: cls.cashdeskPageTabs,
				panel: cls.cashdeskPageTabsPanel,
				list: cls.cashdeskPageTabsList,
			}}
			defaultValue='info'
			value={value}
			onChange={(v) => setValue(v as CashdeskPageTabValues)}
		>
			<Tabs.List>
				<Carousel
					slideSize='auto'
					emblaOptions={{ dragFree: true }}
				>
					<CarouselSlide>
						<Tabs.Tab
							data-test-id='cashdesk-page-info-tab'
							value='info'
						>
							{t('cashdesk-page.info')}
						</Tabs.Tab>
					</CarouselSlide>
					<CarouselSlide>
						<Tabs.Tab
							data-test-id='cashdesk-page-devices-tab'
							value='devices'
						>
							{t('cashdesk-page.devices')}
						</Tabs.Tab>
					</CarouselSlide>
					<CarouselSlide>
						<Tabs.Tab
							data-test-id='cashdesk-page-players-tab'
							value='players'
						>
							{t('cashdesk-page.players')}
						</Tabs.Tab>
					</CarouselSlide>
				</Carousel>
			</Tabs.List>
			<Tabs.Panel value='info'>
				<CashdeskPageForm />
			</Tabs.Panel>
			<Tabs.Panel value='devices'>
				<CashdeskPageDevices />
			</Tabs.Panel>
			<Tabs.Panel value='players'>
				<CashdeskPagePlayers />
			</Tabs.Panel>
		</Tabs>
	);
};
